import { Suspense, lazy } from "react";
// components
import LoadingScreen from "../components/loading-screen";

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import("../pages/LoginPage")));
export const LandingPage = Loadable(lazy(() => import("../pages/LandingPage")));
export const Page404 = Loadable(lazy(() => import("../pages/Page404")));

// TODO: general section
export const Profile = Loadable(lazy(() => import("../pages/general/Profile")));

// TODO: content section

export const BlogList = Loadable(
  lazy(() => import("../pages/contents/blog/BlogList"))
);

export const CreateBlog = Loadable(
  lazy(() => import("../pages/contents/blog/CreateBlog"))
);

export const BlogCategoryList = Loadable(
  lazy(() => import("../pages/contents/blog/BlogCategoryList"))
);

export const SponsorCategoryList = Loadable(
  lazy(() => import("../pages/sponsors/SponsorCategoryList"))
);

export const PhotoCategoryList = Loadable(
  lazy(() => import("../pages/contents/Photo/PhotoCategoryList"))
);

export const VideoCategoryList = Loadable(
  lazy(() => import("../pages/contents/Video/VideoCategoryList"))
);

export const FeatureCategoryList = Loadable(
  lazy(() => import("../pages/contents/feature/FeatureCategoryList"))
);

export const ViewBlog = Loadable(
  lazy(() => import("../pages/contents/blog/ViewEditBlog"))
);

export const FeatureList = Loadable(
  lazy(() => import("../pages/contents/feature/FeatureList"))
);

export const CreateFeature = Loadable(
  lazy(() => import("../pages/contents/feature/CreateFeature"))
);

export const ViewFeature = Loadable(
  lazy(() => import("../pages/contents/feature/ViewEditFeature"))
);

export const BannerList = Loadable(
  lazy(() => import("../pages/contents/banner/BannerList"))
);

export const CreateBanner = Loadable(
  lazy(() => import("../pages/contents/banner/CreateBanner"))
);

export const ViewBanner = Loadable(
  lazy(() => import("../pages/contents/banner/ViewEditBanner"))
);

// TODO: seasons

export const CreateSeason = Loadable(
  lazy(() => import("../pages/seasons/CreateSeason"))
);

export const Seasons = Loadable(lazy(() => import("../pages/seasons/Seasons")));

export const SeasonList = Loadable(
  lazy(() => import("../pages/seasons/SeasonList"))
);

export const ViewEditSeason = Loadable(
  lazy(() => import("../pages/seasons/ViewEditSeason"))
);
// ==================÷

// TODO: champions

export const CreateChampion = Loadable(
  lazy(() => import("../pages/champions/CreateChampion"))
);

export const Champions = Loadable(
  lazy(() => import("../pages/champions/Champions"))
);

export const ChampionList = Loadable(
  lazy(() => import("../pages/champions/ChampionsList"))
);

export const ViewEditChampion = Loadable(
  lazy(() => import("../pages/champions/ViewEditChampion"))
);
// ==================÷

// TODO: stadium

export const CreateStadium = Loadable(
  lazy(() => import("../pages/stadium/CreateStadium"))
);

export const StadiumList = Loadable(
  lazy(() => import("../pages/stadium/StadiumList"))
);

export const ViewEditStadium = Loadable(
  lazy(() => import("../pages/stadium/ViewEditStadium"))
);

// TODO: games

export const CreateGame = Loadable(
  lazy(() => import("../pages/games/CreateGame"))
);

export const GameList = Loadable(lazy(() => import("../pages/games/GameList")));

export const GameDetail = Loadable(
  lazy(() => import("../pages/games/GameDetail"))
);

// TODO: fan-choice

export const CreateFanChoice = Loadable(
  lazy(() => import("../pages/fanchoice/CreateFanChoice"))
);

export const FanChoiceList = Loadable(
  lazy(() => import("../pages/fanchoice/FanChoiceList"))
);

export const FanChoiceDetail = Loadable(
  lazy(() => import("../pages/fanchoice/FanChoiceDetail"))
);

// TODO: fan-voice

export const FanVoiceList = Loadable(
  lazy(() => import("../pages/fanvoice/FanVoiceList"))
);

// TODO: lineups

export const LineUp = Loadable(lazy(() => import("../sections/games/LineUp")));

// TODO: key persons

export const CreateKeyPerson = Loadable(
  lazy(() => import("../pages/keyperson/CreateKeyPerson"))
);

export const KeyPersonList = Loadable(
  lazy(() => import("../pages/keyperson/KeyPersonList"))
);

export const ViewEditKeyPerson = Loadable(
  lazy(() => import("../pages/keyperson/ViewEditKeyPerson"))
);

/////////////////////=======================

// TODO: teams

export const CreateTeam = Loadable(
  lazy(() => import("../pages/teams/CreateTeam"))
);

export const TeamList = Loadable(lazy(() => import("../pages/teams/TeamList")));
export const Team = Loadable(lazy(() => import("../pages/teams/Team")));

export const ViewEditTeam = Loadable(
  lazy(() => import("../pages/teams/ViewEditTeam"))
);

/////////////////////=======================

// TODO: positions

export const CreatePosition = Loadable(
  lazy(() => import("../pages/positions/CreatePosition"))
);

export const PositionList = Loadable(
  lazy(() => import("../pages/positions/PositionList"))
);

export const ViewEditPosition = Loadable(
  lazy(() => import("../pages/positions/ViewEditPosition"))
);
// ==================÷

// TODO: manage
export const FaqList = Loadable(
  lazy(() => import("../pages/managements/faq/FaqList"))
);

export const CreateFaq = Loadable(
  lazy(() => import("../pages/managements/faq/CreateFaq"))
);

export const CreateVideoHub = Loadable(
  lazy(() => import("../pages/contents/Video/CreateVideoHub"))
);

export const VideoList = Loadable(
  lazy(() => import("../pages/contents/Video/VideoList"))
);

export const EditVideoHub = Loadable(
  lazy(() => import("../pages/contents/Video/EditVideoForm"))
);

export const CreatePhoto = Loadable(
  lazy(() => import("../pages/contents/Photo/CreatePhoto"))
);

export const PhotoList = Loadable(
  lazy(() => import("../pages/contents/Photo/PhotoList"))
);

export const EditPhoto = Loadable(
  lazy(() => import("../pages/contents/Photo/EditPhotoForm"))
);

// TODO: manage
export const PlayerList = Loadable(
  lazy(() => import("../pages/contents/player/PlayerList"))
);

export const VerifiedPlayerList = Loadable(
  lazy(() => import("../pages/verified/players/VerifiedPlayerList"))
);

export const CreateVerifiedPlayer = Loadable(
  lazy(() => import("../pages/verified/players/CreateVerifiedPlayer"))
);

export const CoachList = Loadable(
  lazy(() => import("../pages/contents/coach/CoachList"))
);

export const VerifiedCoachList = Loadable(
  lazy(() => import("../pages/verified/coaches/VerifiedCoachList"))
);

export const CreateVerifiedCoach = Loadable(
  lazy(() => import("../pages/verified/coaches/CreateVerifiedCoach"))
);

export const TechnicalList = Loadable(
  lazy(() => import("../pages/contents/technical/TechnicalList"))
);

// TODO: players====================

export const ViewEditPlayer = Loadable(
  lazy(() => import("../pages/contents/player/ViewEditPlayer"))
);

export const ViewEditVerifiedPlayer = Loadable(
  lazy(() => import("../pages/verified/players/ViewEditVerifiedPlayer"))
);

/////////////////////=======================

// TODO: coach====================

export const ViewEditCoach = Loadable(
  lazy(() => import("../pages/contents/coach/ViewEditCoach"))
);

// TODO: coach====================

export const ViewEditVerifiedCoach = Loadable(
  lazy(() => import("../pages/verified/coaches/ViewEditVerifiedCoach"))
);

/////////////////////=======================

// TODO: coach====================

export const ViewEditTechnical = Loadable(
  lazy(() => import("../pages/contents/technical/ViewEditTechnical"))
);

// TODO: users====================

export const UsersList = Loadable(
  lazy(() => import("../pages/contents/users/UsersList"))
);

/////////////////////=======================

/////////////////////=======================

// TODO: squads====================

export const SquadList = Loadable(
  lazy(() => import("../pages/squads/SquadList"))
);

/////////////////////=======================

export const CreateSquad = Loadable(
  lazy(() => import("../pages/squads/CreateSquad"))
);

/////////////////////=======================

// TODO: sponsors====================

export const SponsorList = Loadable(
  lazy(() => import("../pages/sponsors/SponsorList"))
);

/////////////////////=======================

export const CreateSponsor = Loadable(
  lazy(() => import("../pages/sponsors/CreateSponsor"))
);

export const ViewEditSponsor = Loadable(
  lazy(() => import("../pages/sponsors/ViewEditSponsors"))
);

// TODO: admins====================

export const AdminList = Loadable(
  lazy(() => import("../pages/admins/AdminList"))
);

/////////////////////=======================

export const CreateAdmin = Loadable(
  lazy(() => import("../pages/admins/CreateAdmin"))
);

export const ViewEditAdmin = Loadable(
  lazy(() => import("../pages/admins/ViewEditAdmins"))
);

/////////////////////=======================
/////////////////////=======================
